// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"56db0c5f","152":"56db0c5f","402":"56db0c5f","635":"56db0c5f","662":"56db0c5f"}[chunkId] + ".chunk.css";
};